export default __webpack_public_path__ + "static/media/dots-grey.1c7bedee.svg";